import StoredLayout from '../../layouts/StoredLayout'
import DefaultTables from './DefaultTables'
export default StoredLayout(DefaultTables)
